import { useEffect, useState } from "react";
import "./HeroBanner.css";
import banner1 from "../../Images/bannerImageT1.png";
import banner2 from "../../Images/bannerImageT4.png";
import banner3 from "../../Images/bannerImageT2.png";

const banners = [banner1, banner2, banner3];

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % banners.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 + banners.length) % banners.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="w-full overflow-hidden">
      <div className="relative w-full h-[24vh] sm:h-[32vh] md:h-[42vh] lg:h-[52vh] min-h-[160px] duration-700">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-110 blur-xl"
          style={{ backgroundImage: `url(${banners[current]})` }}
        ></div>
        <div className="absolute inset-0 bg-black/10"></div>

        <div
          className="relative z-10 w-full h-full bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${banners[current]})` }}
        ></div>

        <button
          type="button"
          onClick={goPrev}
          aria-label="Previous banner"
          className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-20 bg-black/40 hover:bg-black/60 text-white w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center"
        >
          ‹
        </button>

        <button
          type="button"
          onClick={goNext}
          aria-label="Next banner"
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-20 bg-black/40 hover:bg-black/60 text-white w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center"
        >
          ›
        </button>
      </div>
    </section>
  );
}
